import React, { FC } from 'react';
type IProps = {
    onExport: () => void;
    disabled?: boolean;
}

const ExportButton: FC<IProps> = ({onExport, disabled = false}) => {
    return (
        <>
            <button
                type="button"
                onClick={onExport}
                disabled={disabled}
                className="w-full max-w-[220px] px-4 py-2.5 text-sm font-semibold text-white bg-custom-500 border border-custom-500 rounded-md hover:bg-custom-600 hover:border-custom-600 focus:outline-none focus:ring-2 focus:ring-custom-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center gap-2"
            >
                <i className="ri-download-2-line align-baseline"></i>
                <span>Export CSV</span>
            </button>
        </>
    );
};

export default ExportButton;
